import { SET_SEARCH_PREFERENCES } from 'app/actions/types';

const initialState = {};

// eslint-disable-next-line complexity
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_SEARCH_PREFERENCES: {
      return {
        ...state,
        ...action.preferences,
      };
    }
    default:
      return state;
  }
};
